import { Result } from '@blade/std-lib'

import { safeInvoke } from './tauri-secure-storage-util'

export async function getApiSettings() {
  return (
    await safeInvoke<{ settings: string | null }>('get_api_settings', {
      payload: {},
    })
  ).pipe(Result.map((dto) => dto.settings ?? undefined))
}

export async function setApiSettings(settings: string) {
  return (
    await safeInvoke<unknown>('set_api_settings', {
      payload: { settings },
    })
  ).pipe(Result.map(() => undefined))
}

export async function clearApiSettings() {
  return (
    await safeInvoke<unknown>('clear_api_settings', {
      payload: {},
    })
  ).pipe(Result.map(() => undefined))
}
